import { render, staticRenderFns } from "./reviewers_container.vue?vue&type=template&id=1ffa0472"
import script from "./reviewers_container.vue?vue&type=script&lang=js"
export * from "./reviewers_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports